// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../../../../node_modules/@rsbuild/core/compiled/css-loader/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../../node_modules/@rsbuild/core/compiled/css-loader/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.jaGTXnNbcIAFZU2xIskd{flex-direction:column;flex-grow:1;width:620px;max-width:calc(100% - 88px);margin:0 auto;display:flex}@media (min-width:992px){.jaGTXnNbcIAFZU2xIskd{width:760px}}._vNDwPQOtEkGiyRNw0pC{justify-content:space-between;align-items:center;padding:64px 20px 0;display:flex}.Mg8v44m0ZtUeOn5DJ2Hk{flex-direction:column;gap:4px;display:flex}.M6K9MKFjrbwGm1nbSlv1{gap:8px;display:flex}.EYrH_NbxkMKRC3qAc6oU{flex-direction:column;gap:21px;height:100%;padding:32px 11px 0 15px;display:flex}.dkmq8midg1EbjUQKskEo{flex-shrink:0;margin:0 7px;padding:4px 0 6px}.dkmq8midg1EbjUQKskEo:before{left:0;right:0}`, ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"content": `jaGTXnNbcIAFZU2xIskd`,
	"membersHeader": `_vNDwPQOtEkGiyRNw0pC`,
	"headerDetails": `Mg8v44m0ZtUeOn5DJ2Hk`,
	"headerActions": `M6K9MKFjrbwGm1nbSlv1`,
	"navBar": `EYrH_NbxkMKRC3qAc6oU`,
	"tabs": `dkmq8midg1EbjUQKskEo`
};
export default ___CSS_LOADER_EXPORT___;
